export default __webpack_public_path__ + "static/media/surprise-face.94191fd2.svg";